// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterPaymentsLogoList_container__VkPSc","list":"FooterPaymentsLogoList_list__oWmmz","item":"FooterPaymentsLogoList_item__g1j2i"};